export default __webpack_public_path__ + "static/media/checkmark-filled.73f2a848.svg";